import { render } from "./AposTable.vue?vue&type=template&id=76f42540&scoped=true"
import script from "./AposTable.vue?vue&type=script&lang=js"
export * from "./AposTable.vue?vue&type=script&lang=js"

import "./AposTable.vue?vue&type=style&index=0&id=76f42540&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f42540"],['__file',"ui/ui/apos/components/AposTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76f42540"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76f42540', __exports__)) {
    api.reload('76f42540', __exports__)
  }
  
  module.hot.accept("./AposTable.vue?vue&type=template&id=76f42540&scoped=true", () => {
    api.rerender('76f42540', render)
  })

}


export default __exports__